export default __webpack_public_path__ + "static/media/spaceShipE2.aea78d06.webp";